import { makeStyles } from '@material-ui/core/styles';

const jsStyles = makeStyles({
  h2: {
    fontSize: '22px',
    fontWeight: 'bold',
  },
  facilitylabel: {
    fontSize: '12px',
    textAlign: 'left',
  },
  selectlabel: {
    textAlign: 'left',
    fontSize: '12px',
    marginLeft: '10px',
    textDecoration: 'underLine',
    '&:hover': {
      cursor: 'pointer',
      color: 'black',
    },
  },
  clearlabel: {
    textAlign: 'left',
    fontSize: '12px',
    marginLeft: '10px',
    textDecoration: 'underLine',
    '&:hover': {
      cursor: 'pointer',
      color: 'black',
    },
  },
  checkbox: {
    padding: '1px',
  },
  facilities: {
    paddingLeft: '7px',
  },
  facilitylables: {
    display: 'flex',
  },
});

export default jsStyles;
